import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsScanStationTrackingUpdateParmInfo } from "./wsScanStationTrackingUpdateParmInfo";

@Injectable()
export class DataService_scanstationtracking {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ScanStationTrackingColumnOptionSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ScanStationTrackingColumnOptionSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTrackingColumnOptionSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ScanStationTrackingSelectList
	//
	//-----------------------------------------------------------------------------------------------------	
	ScanStationTrackingSelectList(FacilityID, Active) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTrackingSelectList?FacilityID=" + FacilityID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilitySelectList
	//
	//-----------------------------------------------------------------------------------------------------	
	FacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetSchoolFacilities?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ScanStationTrackingUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ScanStationTrackingUpdate(parms: wsScanStationTrackingUpdateParmInfo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTrackingUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	

}
